import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setRequiredFilter } from './actions';

const actionRequiredFilterSelector = (state) => state.actionRequiredFilter;

export const useActionRequiredFilter = {
  state: () => {
    return useSelect(actionRequiredFilterSelector);
  },
  actions: () => {
    return {
      setActionRequiredFilter: useAction(setRequiredFilter),
    };
  },
};
